<template>
    <section style="margin:18px;">
        <v-card>
            <v-card-text>
                <v-layout wrap style="padding: 10px;" row>
                    <v-flex xs5 style="margin:18px;">
                        <v-flex>
                            <v-text-field v-model="Name" label='Name'></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-text-field v-model="Email" label='Email'></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-text-field v-model="Qualification" label='Qualification'></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-text-field v-model="Address" label='Address'></v-text-field>
                        </v-flex>
                        <v-flex style="font-size: 14px;font-weight: 500;">Select Course Type :</v-flex>
                        <v-flex>
                            <v-radio-group v-model="Course_Type" row @change="GetCourseList">
                                <v-radio label="Classroom" value="Classroom"></v-radio>
                                <v-radio label="Online" value="Webinar"></v-radio>
                                <v-radio label="Self Paced" value="Online"></v-radio>
                            </v-radio-group>
                        </v-flex>
                    </v-flex>
                    <v-flex xs5 style="margin:18px;">
                            <v-flex style="font-size: 14px;font-weight: 500;">Select Course :</v-flex>
                            <v-flex>
                                <v-select @change="GetPricingAndSchedule" item-value='_id' item-text='Course_Title' return-object v-model="SelectedCourse" :items="Course_List" label="Select Course">
                                    <template slot='selection' slot-scope='{ item }'>
                                        {{ item.Course_Title }}
                                    </template>
                                    <template slot='item' slot-scope='{ item }'>
                                        {{ item.Course_Title }}    
                                    </template>
                                </v-select>
                            </v-flex>
                            <v-layout style="font-size: 14px;font-weight: 500;" row v-if=" Object.keys(Pricing).length > 0">
                                <v-flex>Actual Price  : Rs. {{ Pricing.Actual_Price }}</v-flex>
                                <v-flex>Offer Price   : Rs. {{ Pricing.Discounted_Price }}</v-flex>
                            </v-layout>
                            <section v-if="CourseTypeRequiresBatch(Course_Type)" style="margin:8px 0px;">
                                <v-flex style="font-size: 14px;font-weight: 500;margin:12px 0px;">Select Schedule :</v-flex>
                                <v-flex v-if="!Schedules.length" style="color:#c62828; font-size: 13px; margin-bottom: 8px;">
                                    No batch on this course. Add one under Add Schedule.
                                </v-flex>
                                <v-select v-if="Schedules.length" item-value='_id' return-object v-model="Selected_Schedule" :items="Schedules" label="Select existing batch">
                                    <template slot='selection' slot-scope='{ item }'>
                                        {{ new Date(item.Schedule_Start_Date).toDateString() }} , {{ item.Schedule_Time }}
                                    </template>
                                    <template slot='item' slot-scope='{ item }'>
                                        {{ new Date(item.Schedule_Start_Date).toDateString() }} , {{ item.Schedule_Time }}
                                    </template>
                                </v-select>
                            </section>
                            <section style="margin:8px 0px;">
                                <v-flex style="font-size: 14px;font-weight: 500;">Select Offer : </v-flex>
                                <v-select item-value='_id' item-text='Offer_Name' return-object v-model="SelectedOffer" :items="Offers" label="Select Offers">
                                    <template slot='selection' slot-scope='{ item }'>
                                        {{ item.Offer_Name }} ( Maximum - Rs.  {{ item.Maximum_Amount }} )
                                    </template>
                                    <template slot='item' slot-scope='{ item }'>
                                        {{ item.Offer_Name }} ( Maximum - Rs.  {{ item.Maximum_Amount }} )    
                                    </template>
                                </v-select>
                            </section>
                            <v-flex>
                                <v-flex style="font-size: 14px;font-weight: 500;">Location  :</v-flex>
                                <v-radio-group v-model="Location" row>
                                    <v-radio label="Bangalore" value="Bangalore"></v-radio>
                                    <v-radio label="Pune" value="Pune"></v-radio>
                                </v-radio-group>
                                <v-flex style="font-size: 14px;font-weight: 500;">Offline Payment Mode  :</v-flex>
                                <v-radio-group v-model="Payment_Type" row>
                                    <v-radio label="Cash" value="Cash"></v-radio>
                                    <v-radio label="Debit / Credit Card" value="Card"></v-radio>
                                    <v-radio label="Wallet (Paytm , Google Pay , Etc ,.)" value="Wallet"></v-radio>
                                </v-radio-group>
                            </v-flex>
                    </v-flex>   
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-flex style="text-align: right;">
                    <v-btn color="primary" @click="RegisterUser">Register User</v-btn>
                </v-flex>
            </v-card-actions>
        </v-card>
    </section>
</template>
<script>
import { CourseTypeRequiresBatch, BatchSelectMessage, CourseIdOf, SchedulesForCourseType } from '../util/courseTypes'
export default {
    data(){
        return {

            Name              : "",
            Email             : "",
            Qualification     : "",
            Address           : "",
            Course_Type       : "",
            Course_List       : [],
            SelectedCourse    : {},
            Schedules         : [],
            Pricing           : {},
            Selected_Schedule : {},
            SelectedOffer     : {},
            hideDelimiters    : true,
            cycle             : false,
            Offers            : [],
            Location          : '',
            Payment_Type      : ""

        }
    },
    methods:{
        CourseTypeRequiresBatch,
        ApplySchedules(list){
            this.Schedules = SchedulesForCourseType(list, this.Course_Type)
            if (this.Schedules.length === 1) this.Selected_Schedule = this.Schedules[0]
        },
        ClickSchedule(Schedule){
    
            this.Selected_Schedule = Schedule
        },
        GetCourseList(){

            let data = { 'Course_Type' : this.Course_Type }
            if(this.Course_Type){
                    this.Selected_Schedule ={}
                    this.Course_List       = []
                    this.SelectedCourse    = {}
                    this.Schedules         = []
                    this.Pricing           = {}
    
                this.$http.post(`${this.$store.getters.GetProductionUrl}/course/clientgetcoursebasedontype`,data)
                        .then(response => {
                            
                            this.Course_List = response['data']['response']
                            this.GetOfferList()
                        })
                        .catch(err => {
    
                            this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: "Error While Fetching Data",Color: "red",Close: false});
                        });
            }else{

                 this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: "Select Course Type",Color: "red",Close: false});
            }
        },
        GetPricingAndSchedule(){

            this.Selected_Schedule = {}
            this.Schedules = []
            this.Pricing = {}
            const courseId = this.SelectedCourse && this.SelectedCourse['_id']
            let data = { 'Course_Type' : this.Course_Type , 'Course_Id' : courseId }

            this.$http.post(`${this.$store.getters.GetProductionUrl}/course/getpricingandschedule`,data)
                    .then(response => {
                        
                        if(response['data']['response'] && response['data']['response'][0]){

                            this.Pricing = response['data']['response'][0]
                            this.ApplySchedules(this.Pricing['Schedules'] || [])
                        }
                        return this.$http.post(`${this.$store.getters.GetProductionUrl}/schedules/getschedules`)
                    })
                    .then(response => {
                        const all = (response && response['data'] && response['data']['response']) || []
                        const matched = all.filter(schedule => CourseIdOf(schedule) === String(courseId))
                        if (matched.length) this.ApplySchedules(matched)
                    })
                    .catch(err => {

                        this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: "Error While Fetching Data",Color: "red",Close: false});
                    });

        },
        GetOfferList(){


            this.$http.post(`${this.$store.getters.GetProductionUrl}/offers/getoffers`)
                    .then(response => {
                        
                        this.Offers = response['data']['response'].filter(x => x['Offer_Type'] != 'Coursewise' && x['Offer_Type'] != 'User' && x['Offer_Type'] != 'BuyOneGetOne')
                    })
                    .catch(err => {

                        this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: "Error While Fetching Data",Color: "red",Close: false});
                    });
        },
        RegisterUser(){
            if (CourseTypeRequiresBatch(this.Course_Type) && !(this.Selected_Schedule && this.Selected_Schedule['_id']) && this.Schedules.length === 1) {
                this.Selected_Schedule = this.Schedules[0]
            }
            if (CourseTypeRequiresBatch(this.Course_Type) && !(this.Selected_Schedule && this.Selected_Schedule['_id'])) {
                const extra = this.Schedules.length ? BatchSelectMessage(this.Course_Type) : 'No batch on this course. Add one under Add Schedule.'
                this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: extra, Color: "red", Close: false});
                return
            }

            let data = { }
            data['User']   = { 'Name': this.Name, 'Email': this.Email,'Qualification': this.Qualification,'Address':this.Address }
            data['Course'] = { 'Coupon_Code':this.SelectedOffer['Coupon_Code'], 'User_Amount' : this.Pricing['Discounted_Price'] ,
                               'Courses' : [{ 'Amount':this.Pricing['Discounted_Price'],'Course_Id':this.SelectedCourse['_id'],'Course_Type': this.Course_Type ,'Purchase_Type' : 'Course'}],
                                'Sales_Via' : `Offline_${this.Location}` ,'Payment_Type' : this.Payment_Type  
                            }
            Object.keys(this.Selected_Schedule).length > 0 ? data['Course']['Courses'][0]['Schedule_Id'] = this.Selected_Schedule['_id'] : ''

            this.$http.post(`${this.$store.getters.GetProductionUrl}/register/adminregisteruser`,data)
                    .then(response => {
                        
                        this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: "Successfully Registered",Color: "green",Close: false});
                        this.ClearForm()
                    })
                    .catch(err => {

                        this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: "Error While Fetching Data",Color: "red",Close: false});
                    });
        },
        ClearForm(){

            this.Selected_Schedule = {}
            this.Course_List       = []
            this.SelectedCourse    = {}
            this.Schedules         = []
            this.Pricing           = {}
            this.Name              = ""
            this.Email             = ""
            this.Qualification     = ""
            this.Address           = ""
            this.Course_Type       = ""
            this.SelectedOffer     = {}
            this.Offers            = [],
            this.Location          = ''
            this.Payment_Type      = ''
        }
    },
    mounted(){
        this.$eventHub.$emit("LOADING",'false')
    }
}
</script>
<style>
.ClassForCarousal{
    padding: 14px;
    text-align: center;
    font-size: 13px;
    font-weight: 900;
}
</style>